import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Departement } from 'src/app/shared/models/departement';
import { Region } from 'src/app/shared/models/region';

@Component({
	selector: 'app-region-modal-ajout',
	templateUrl: './region-modal-ajout.component.html',
	styleUrls: ['./region-modal-ajout.component.scss']
})
export class RegionModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	listDepartement: Departement[];
	listSelectedDepartement: Departement[] = [];

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		]),
		sigle: new FormControl('', [
			Validators.required
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.facade.departementService.getAllDepartement().subscribe({
			next: (val) => {
				this.listDepartement = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const region = new Region();
		region.departements = this.listSelectedDepartement;
		region.name = this.formEdit.get('name').value;
		region.sigle = this.formEdit.get('sigle').value;
		this.facade.regionService.addRegion(region).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	isDepartementCheck(dep: Departement): boolean {
		return this.listSelectedDepartement?.some(
			(specItfc) => specItfc.id === dep.id
		);
	}

	updateSelectedDepartement(e: any, dep: Departement) {
		if (e.target.checked) {
			if (!this.listSelectedDepartement.some((z) => z.id === dep.id)) {
				this.listSelectedDepartement.push(dep);
			}
		} else {
			if (this.listSelectedDepartement.some((z) => z.id === dep.id)) {
				this.listSelectedDepartement = this.listSelectedDepartement.filter(
					(z) => z.id !== dep.id
				);
			}
		}
	}

	get name() {
		return this.formEdit.get('name');
	}
	get sigle() {
		return this.formEdit.get('sigle');
	}
}
